module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/6_ba52d6e5b454e07e71ceba43051e3a95.png";